import {Pipe, PipeTransform} from '@angular/core';

import {GPTranslateService} from './translate.service';

@Pipe({
  name: 'getTransIdsDisplay',
  pure: true
})
export class GetTransIdsDisplayPipe implements PipeTransform {

  constructor(private translate: GPTranslateService) {
  }

  transform(value: string[], trigger: number): string {

    if (!value || value.length === 0) {
      return '';
    }

    return this.translate.getDisplayTranslation(value);
  }

}
